import { useQuery } from "@tanstack/react-query"

export type LookupProjekt = { id: number | string; name?: string | null; status?: string | null }
type LookupAntwort = { projects?: LookupProjekt[] | null } | null

/**
 * Der Vorgang aus HERO (Bezeichnung + aktueller Status) — EIN Lookup, geteilt
 * mit `HeroVorgangName` und dem Kalender-Fenster (gleicher Cache-Schluessel).
 */
export function useHeroVorgang(
  tenantSlug: string | null | undefined,
  projectId: number | string | null | undefined,
  enabled = true,
): LookupProjekt | undefined {
  const q = useQuery<LookupAntwort>({
    queryKey: ["hero-lookup-project", tenantSlug, String(projectId ?? "")],
    queryFn: async () => {
      const r = await fetch(
        `/api/v1/hero/lookup?tenant=${encodeURIComponent(tenantSlug || "")}&project_id=${encodeURIComponent(String(projectId))}`,
        { credentials: "include" },
      )
      if (!r.ok) return null
      return r.json()
    },
    enabled: enabled && !!tenantSlug && !!projectId,
    staleTime: 60_000,
    retry: false,
  })
  return (q.data?.projects || []).find((p) => String(p.id) === String(projectId))
}
